import { cookie } from '@tencent/qd-lib';
export default cookie;
